// extracted by mini-css-extract-plugin
export default {"Anchor":"Z5BTlaIyM0Swyb7hzzeg","Anchors":"RNVfh4NSjeScjloAcFcv","Links":"aVzPGOSkun10SwzCpjri"};